import type { ChargeName } from './charge.ts'

type ProvinceTaxRates = {
  GST: number
  PST: number
  HST: number
  QST?: number
}

export const canadianProvinceTaxRates: Record<string, ProvinceTaxRates> = {
  AB: { GST: 0.05, PST: 0.0, HST: 0.0 },
  BC: { GST: 0.05, PST: 0.07, HST: 0.0 },
  MB: { GST: 0.05, PST: 0.07, HST: 0.0 },
  NB: { GST: 0.0, PST: 0.0, HST: 0.15 },
  NL: { GST: 0.0, PST: 0.0, HST: 0.15 },
  NS: { GST: 0.0, PST: 0.0, HST: 0.14 },
  NT: { GST: 0.05, PST: 0.0, HST: 0.0 },
  NU: { GST: 0.05, PST: 0.0, HST: 0.0 },
  ON: { GST: 0.0, PST: 0.0, HST: 0.13 },
  PE: { GST: 0.0, PST: 0.0, HST: 0.15 },
  QC: { GST: 0.05, PST: 0.0, HST: 0.0, QST: 0.09975 },
  SK: { GST: 0.05, PST: 0.06, HST: 0.0 },
  YT: { GST: 0.05, PST: 0.0, HST: 0.0 },
}

type TaxCharge = {
  name: ChargeName
  rate: number
}

export function getCanadianTaxCharges(
  originProvinceCode: string,
  destinationProvinceCode: string,
): TaxCharge[] {
  const rates = canadianProvinceTaxRates[destinationProvinceCode.toUpperCase()]
  if (!rates) return []

  const taxes: TaxCharge[] = []

  if (rates.HST > 0) {
    taxes.push({ name: 'hst', rate: rates.HST })
  }
  if (rates.GST > 0) {
    taxes.push({ name: 'gst', rate: rates.GST })
  }
  if (rates.PST > 0) {
    taxes.push({ name: 'pst', rate: rates.PST })
  }
  if (rates.QST && rates.QST > 0 && originProvinceCode.toUpperCase() === 'QC') {
    taxes.push({ name: 'qst', rate: rates.QST })
  }

  return taxes
}
